import { render, staticRenderFns } from "./add-piano-company.vue?vue&type=template&id=5382d46f&scoped=true&"
import script from "./add-piano-company.vue?vue&type=script&lang=js&"
export * from "./add-piano-company.vue?vue&type=script&lang=js&"
import style0 from "./add-piano-company.vue?vue&type=style&index=0&id=5382d46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382d46f",
  null
  
)

export default component.exports